import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { UserAuthenticationService } from "../_services/authentication.service";
import { Helpers } from "../../../helpers";

@Component({
    selector: 'app-user-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class UserLogoutComponent implements OnInit {

    constructor(private _router: Router,
        private _authService: UserAuthenticationService) {
    }

    ngOnInit(): void {
        Helpers.setLoading(true);
        // reset login status
        this._authService.logout();
        this._router.navigate(['/owner/login']);
    }
}


// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/user/logout/logout.component.ts